import React, { useEffect, useState } from 'react';
import { prefixUrl } from '../../../../utils/utilsData';
import DynaSelectBox from '../../DynaView/DynaSelectBox';
import { FilterIcon } from '../ExportSVG';
import _axios from '../../../../httpService';
import Loader from '../../../Loader/Loader';
import { toast } from "react-toastify";
import './UnenteredInsurance.scss';

const UnenteredInsurance = () => {
  const [insuranceType, setInsuranceType] = useState([]);
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [isLoad, setIsLoad] = useState(false);
  const [typeId, setTypeId] = useState("");  // بیمه فعال
  const [insuranceNumbers, setInsuranceNumbers] = useState([]); // لیست شماره‌ها
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 50;
  const paginatedData = insuranceNumbers.slice(0, currentPage * pageSize);

  const getYearsList = async () => {
    const response = await _axios.get(prefixUrl() + "/insurance/?request=insuranceYears");
    if (response.data.status) {
      const years = response.data.data.years;
      setYearsList(years);
      return years[0]?.value;
    } else {
      toast.error(response.data.message);
      return null;
    }
  };

  const getInsuranceNumbers = async (year = selectedYear) => {
    const toastId = toast.info("در حال دریافت اطلاعات...", { autoClose: false });

    const response = await _axios.get(prefixUrl() + `/insurance/?request=notSubmittedInsuranceNumbers&year=${year}`);
    if (response.data.status) {
      const data = response.data.data;
      setInsuranceType(data);

      if (data.length > 0) {
        setTypeId(data[0].typeId);
        setInsuranceNumbers(data[0].notSubmittedNumbers || []);
      }

      toast.dismiss(toastId);
      toast.success("اطلاعات با موفقیت دریافت شد.");
    } else {
      toast.dismiss(toastId);
      toast.error(response.data.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const year = await getYearsList();
        if (year) {
          setSelectedYear(year);
          await getInsuranceNumbers(year);
        }
        setIsLoad(true);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleTypeClick = (item) => {
    setTypeId(item.typeId);
    setInsuranceNumbers(item.notSubmittedNumbers || []);
    setCurrentPage(1);
  };

  try {
    return !isLoad ? (
      <Loader />
    ) : (
      <section className='unentered-insurance'>
        <div className='filter-box'>
          <DynaSelectBox
            options={yearsList}
            hasFilter={false}
            label={"انتخاب سال"}
            className={"solid-dyna-input"}
            value={selectedYear}
            onChange={(data) => setSelectedYear(data.value)}
          />
          <button className="filter-btn" onClick={() => getInsuranceNumbers()}>
            <FilterIcon />
          </button>
        </div>

        <ul className={"insurance-type"}>
          {insuranceType.length > 0 && insuranceType.map((item, index) => (
            <li key={"type" + index} onClick={() => handleTypeClick(item)}>
              <div className={`box-img ${typeId === item?.typeId && "box-img-active"}`}>
                <img src={item?.typePicture} alt={"insurance-type"} />
              </div>
              <div className='box-desc'>
                <h5>{item?.typeName}</h5>
                <span>{item?.count}</span>
              </div>
            </li>
          ))}
        </ul>

        <div className='insurance-box'>
          {insuranceNumbers.length > 0 ?
            <div className="insurance-list">
              {paginatedData.map((num, index) => (
                <div key={index} className="insurance-item">
                  <span className="insurance-index">{index + 1} .</span>
                  <span className="insurance-number">{num}</span>
                </div>
              ))}
              {paginatedData.length < insuranceNumbers.length && (
                <div className='more-button-container'>
                  <button onClick={() => setCurrentPage(currentPage + 1)}>نمایش بیشتر...</button>
                </div>
              )}
            </div> :
            <p className='no-data-message'>اطلاعاتی برای نمایش وجود ندارد.</p>
          }
        </div>
      </section>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default UnenteredInsurance;